import { AssessmentMethodType } from '@schooly/api';
import { GridCellMiddleware } from '@schooly/components/data-grid';

import { AssessmentCellState } from './types';

export const createLoadingMiddleware = <TArgs extends any[], TResult>(): GridCellMiddleware<
  TArgs,
  TResult,
  AssessmentCellState
> => {
  return async ({ cellContext, proceed, args }) => {
    cellContext.updateCellState(cellContext.cellId, { status: 'loading' });

    try {
      const result = await proceed(...args);

      setTimeout(() => {
        cellContext.updateCellState(cellContext.cellId, { status: 'success' }, 2000);
      }, 500);

      return result;
    } catch (error) {
      cellContext.updateCellState(cellContext.cellId, { status: 'error' }, 3000);
      throw error;
    }
  };
};

export const createAssessmentMiddlewareConfig = () => ({
  [AssessmentMethodType.Score]: [createLoadingMiddleware()],
  [AssessmentMethodType.Grade]: [createLoadingMiddleware()],
  [AssessmentMethodType.Comment]: [createLoadingMiddleware()],
});

export const middlewareConfig = createAssessmentMiddlewareConfig();
